/***
 * Created on 2025/1/3
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useState} from 'react';
import {I18nextProvider, useTranslation} from "react-i18next";
import {QueryClient, QueryClientProvider, useMutation, useQueryClient} from "@tanstack/react-query";
import sharedI18n from "common/SharedI18n";
import PasswordInput from "../common/form/password_input";
import {useOnChange} from "common/Hook";
import {apiPost} from "../../service/api";
import md5 from "blueimp-md5";
import Captcha from "../common/captcha";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // default: true
        },
    },
});


function SamlLinkAccount({}) {
    const { t } = useTranslation();
    const url = new URL(location.href);
    const {values, setValues, onChange} = useOnChange({
        password: ""
    });
    const queryClient = useQueryClient();

    const linkMutation = useMutation({
        mutationFn: async (data) => await apiPost(`/ajax/saml/link_account`, data),
        onSuccess: (data) => {
            onSubmit();
        },
        onError: (error, variables, context) => {
             queryClient.invalidateQueries(['get_captcha_image']);
        }
    });

    const onLinkSubmit = async (e) => {
        const data = {
            password: md5(values.password)
        }
        if (values?.captcha) {
            data.captcha = values.captcha;
        }
        await linkMutation.mutateAsync(data);
    }

    const onSubmit = (e) => {
        const state = url.searchParams.get('state');
        location.href = state ? state : '/account';
    };

    return (
        <section className="common-page-wrapper">
            <div className="common-page-header">{t('@Link Your Accounts@')}</div>
            <div className="common-page-body">
                <p>{t('@We detected that your {{idp_name}} account is associated with an existing QNAP ID ({{email}}).@',
                    {
                        idp_name: url.searchParams.get('saml_sso_id'),
                        email: url.searchParams.get('email')
                    })
                }</p>
                <p>{t('@To link your organization credentials with your QNAP ID, enter your QNAP ID password.@')}</p>
                <div className="common-form-group">
                    <PasswordInput
                        required={true}
                        label={t('@Password@')}
                        placeholder={t('@Password@')}
                        name="password"
                        value={values.password}
                        onChange={onChange}
                    />
                </div>
                <p className="text-remind">
                    {t('@Note: Linking your accounts will not change any existing permissions or settings.@')}
                </p>
            </div>

            <Captcha value={values.captcha} inputChangeHandler={onChange} resetValue={() => setValues(prev => ({...prev, captcha: ''}))}/>

            <div className="common-page-footer">
                <div className="q-btn-group btn-align-right">
                <button className="q-btn q-btn--primary btn-medium btn-rounded-normal" onClick={onLinkSubmit} disabled={!values?.password}>{t('@Link Accounts@')}</button>
                    <button className="q-btn q-btn--default btn-medium btn-rounded-normal" onClick={onSubmit}>{t('@Cancel@')}</button>
                </div>
            </div>
        </section>
    );
}

const SamlLinkAccountIndex = () => {
    return (
        <I18nextProvider i18n={sharedI18n}>
            <QueryClientProvider client={queryClient}>
                <SamlLinkAccount/>
            </QueryClientProvider>
        </I18nextProvider>
    )
}

export default SamlLinkAccountIndex;